import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconInfinityUpgrade = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={29}
    fill="none"
    viewBox="0 0 42 29"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-infinity-upgrade_svg__a)">
      <path
        fill="url(#icon-infinity-upgrade_svg__b)"
        d="M27.797 6.29c3.125 0 5.703 2.538 5.703 5.663v1.133c0 3.125-2.578 5.664-5.703 5.703-1.485 0-2.93-.625-3.985-1.68L21 14.297l-2.852 2.812a5.648 5.648 0 0 1-3.984 1.641A5.668 5.668 0 0 1 8.5 13.086v-1.133c0-3.125 2.54-5.664 5.664-5.703 1.484 0 2.93.625 3.984 1.68L21 10.742l2.813-2.812a5.648 5.648 0 0 1 3.984-1.64ZM16.39 15.351l2.812-2.813-2.812-2.851c-.586-.586-1.407-.899-2.227-.899A3.15 3.15 0 0 0 11 11.953v1.133c0 1.758 1.406 3.164 3.164 3.203.82 0 1.64-.352 2.227-.937ZM31 13.086v-1.133c0-1.758-1.445-3.203-3.203-3.164-.82 0-1.64.313-2.227.899l-2.812 2.851 2.812 2.813a3.202 3.202 0 0 0 2.227.937A3.218 3.218 0 0 0 31 13.086Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-infinity-upgrade_svg__b"
        x1={31}
        x2={12.025}
        y1={3}
        y2={22.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
      <filter
        id="icon-infinity-upgrade_svg__a"
        width={41}
        height={35}
        x={0.5}
        y={-3}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5332"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5332"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5332"
          result="effect2_dropShadow_6025_5332"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5332"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconInfinityUpgrade;
